import { IMenuAction, IMenu } from 'models/menu';

/** Action Types */
export const SIDEMENU_SETACTIVEKEY: string = 'sidemenu/SIDEMENU_SETACTIVEKEY';
export const SIDEMENU_SETSELECTEDKEYS: string = 'sidemenu/SIDEMENU_SETSELECTEDKEYS';
export const SIDEMENU_SETOPENKEYS: string = 'sidemenu/SIDEMENU_SETOPENKEYS';
export const SIDEMENU_CLEARDATA: string = 'sidemenu/SIDEMENU_CLEARDATA';

const initialState: IMenu = {
	activeKey: '',
	selectedKeys: [],
	openKeys: [],
};

/** Reducer */
export function sideMenuReducer(state = initialState, action: IMenuAction) {
	switch (action.type) {
		case SIDEMENU_SETACTIVEKEY:
			return Object.assign({}, state, {
				activeKey: action.payload.activeKey,
			});
		case SIDEMENU_SETSELECTEDKEYS:
			return Object.assign({}, state, {
				selectedKeys: action.payload.selectedKeys,
			});
		case SIDEMENU_SETOPENKEYS:
			return Object.assign({}, state, {
				openKeys: action.payload.openKeys,
			});
		case SIDEMENU_CLEARDATA:
			return Object.assign({}, state, initialState);
		default:
			return state;
	}
}

/** Actions */
export function setSideMenuActiveKey(activeKey: string): IMenuAction {
	return {
		type: SIDEMENU_SETACTIVEKEY,
		payload: {
			activeKey,
		},
	};
}

export function setSideMenuSelectedKeys(selectedKeys: string[]): IMenuAction {
	return {
		type: SIDEMENU_SETSELECTEDKEYS,
		payload: {
			selectedKeys,
		},
	};
}

export function setSideMenuOpenKeys(openKeys: string[]): IMenuAction {
	return {
		type: SIDEMENU_SETOPENKEYS,
		payload: {
			openKeys,
		},
	};
}

export function clearSideMenuData(): IMenuAction {
	return {
		type: SIDEMENU_CLEARDATA,
	};
}
